import * as moment from 'moment';
import { FormResponseTransformer } from "@/helpers/forms/form-response.transformer";
import { DateFormat } from '@/helpers/date-format';

export class FormTransformer {

    static transform(obj) {
        let form = {};
        form.id = obj.id;
        form.id_alt = obj.attributes.id_display;
        form.order_id = obj.attributes.order_id;
        form.asset_class = obj.attributes.asset_class;
        form.asset_code = obj.attributes.asset_code;
        form.asset_classes = obj.attributes.asset_classes;
        form.completed_at = obj.attributes.completed_at ? moment.utc(obj.attributes.completed_at).toISOString() : null;
        // form.completed_at = obj.attributes.completed_at;
        form.completed_at_alt = DateFormat.formatDate(obj.attributes.completed_at);
        form.completed_by = obj.attributes.completed_by;
        form.asset_name = obj.attributes.asset_name;
        form.type = obj.attributes.type;
        form.status = obj.attributes.status.toUpperCase();
        form.created_at = DateFormat.formatDate(obj.attributes.created_at);
        // form.responses = FormResponseTransformer.transformArray(obj.attributes.responses.data);
        // GPS/map related properties
        form.asset_lat = obj.attributes.asset_lat;
        form.asset_lng = obj.attributes.asset_lng;
        form.start_datetime = obj.attributes.start_datetime ? moment.utc(obj.attributes.start_datetime).toISOString() : null;
        // form.start_datetime = obj.attributes.start_datetime;
        form.device_lat_start = obj.attributes.device_lat_start;
        form.device_lng_start = obj.attributes.device_lng_start;
        form.device_accuracy_start = obj.attributes.device_accuracy_start;
        form.device_lat_finish = obj.attributes.device_lat_finish;
        form.device_lng_finish = obj.attributes.device_lng_finish;
        form.device_accuracy_finish = obj.attributes.device_accuracy_finish;
        form.engineer_required = obj.attributes.engineer_required;
        form.finish_datetime = obj.attributes.finish_datetime ? moment.utc(obj.attributes.finish_datetime).toISOString() : null;
        // form.finish_datetime = obj.attributes.finish_datetime;
        form.finish_datetime_alt = DateFormat.formatDateTime(obj.attributes.finish_datetime);
        form.notes = obj.attributes.notes;
        form.hs_notes = obj.attributes.hs_notes;
        form.asset_id = obj.attributes.asset_id;
        form.order_operation_id = obj.attributes.order_operation_id;

        return form;
    }

    static transformArray(array = []) {
        let data = [];
        array.map(function (item) {
            data.push(FormTransformer.transform(item));
        });
        return data;
    }
}


// WEBPACK FOOTER //
// ./src/helpers/forms/form.transformer.js